const e=async(e,t,n)=>{let{data:r}=await e.get(`/orgs/${n}/apps/${t}/users`);return r};export{e as getOrgAppUsers};
//# sourceMappingURL=get-org-app-users.mjs.map